<script>
    import SignInForm from "./SignInForm.svelte";
    import {getAuth} from "../../config/firebase-config";
    import {user} from "./admin-store";
    import {onMount} from "svelte";
    import AdminMenu from "./AdminMenu.svelte";

    function signOut() {
        getAuth().signOut()
            .then(res => {
                sessionStorage.removeItem('signed');
                user.set(null);
            })
            .catch(err => {console.log(err)})
    }

    onMount(() => {
        user.set(sessionStorage.getItem('signed'))
    })
</script>

<!--------------------------------------------------------------------------------------------------------------------->

<div>
    {#if $user !== null}
        <AdminMenu on:signout={signOut} />
    {:else}
        <SignInForm />
    {/if}
</div>

<!--------------------------------------------------------------------------------------------------------------------->
